// import Buttons from '../buttons/buttons';
import './sectionCTA.css';

function SectionsCTA({Titulo,cor,srcImg}) {
    // const valida = () => {
    //   console.log("Comprou");
    // }

    return (
      <div className="SectionsCTA">
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
                <h1 className='tituloCTA'>{Titulo}</h1>
            </div>
            {/* <div className='col-md-12'>
              <img className='img-sectionsCTA' src={srcImg} alt={Titulo}/>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
  
  export default SectionsCTA;